import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagGM = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#A2001D",
  d: "M25 0C14.663 0 5.793 6.272 1.986 15.217h46.025C44.205 6.272 35.335 0 25 0Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#496E2D",
  d: "M25 50c10.335 0 19.205-6.272 23.012-15.217H1.987C5.794 43.728 14.664 50 24.999 50Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M49.138 18.479H.861A25.027 25.027 0 0 0 0 25c0 2.257.3 4.443.861 6.522h48.277c.56-2.08.862-4.265.862-6.522 0-2.256-.301-4.442-.862-6.521Z"
}));
FlagGM.displayName = 'FlagGM';
export default withFlagWrapper(FlagGM);
//# sourceMappingURL=index.js.map